<template>
  <pf-panel v-if="products.length > 0 || showIfEmpty" variant="bordered" class="wizard-summary-section" v-bind="ouiaProps">
    <pf-panel-header>
      <pf-title h="2" class="pf-v6-u-mb-md">{{ $t('Prodotti associati al nome a dominio {0}', [group]) }}</pf-title>
      <slot />
    </pf-panel-header>
    <pf-panel-main>
      <pf-panel-main-body>
        <slot name="productsList">
          <catalog-product-list
            v-if="products.length"
            :items="products"
            :currency="currency"
            :hide-plus-vat="hidePlusVat"
            :hide-price="freePeriod"
            :show-qt="showQt"
            :always-full-price="alwaysFullPrice"
          />
        </slot>
      </pf-panel-main-body>
    </pf-panel-main>
    <slot name="footer">
      <pf-panel-footer v-if="products.length > 0 && !freePeriod" class="riepilogo-wrapper">
        <wizard-summary-totals durata="Annuale" :gruppo="group" :title="$t('Costo totale annuale')" />
        <wizard-summary-totals durata="Mensile" :gruppo="group" :title="$t('Costo totale mensile')" />
      </pf-panel-footer>
      <pf-panel-footer v-else-if="products.length === 0 && !freePeriod" class="riepilogo-wrapper">
        {{ $t('Nessun prodotto selezionato') }}
      </pf-panel-footer>
    </slot>
  </pf-panel>
</template>

<style scoped>
.riepilogo-wrapper {
  background-color: var(--pf-t--global--background--color--secondary--default);
  padding: 10px;
  text-align: right;
}

.wizard-summary-section {
  margin-top: var(--pf-v6-global--spacer--xl);
  --pf-v6-c-panel__main-body--PaddingTop: 0;
  --pf-v6-c-panel__main-body--PaddingBottom: 0;
  --pf-v6-c-panel__main-body--PaddingLeft: 1px;
  --pf-v6-c-panel__main-body--PaddingRight: 1px;
}
</style>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { type Product } from '@/wizard';
import CatalogProductList from '../../catalog-product-list.vue';
import WizardSummaryTotals from '../summary/wizard-summary-totals.vue';

const props = withDefaults(
  defineProps<
    OUIAProps & {
      products: Product[];
      group: string;
      freePeriod: boolean;
      currency: 'EUR' | 'CHF';
      hidePlusVat?: boolean;
      showIfEmpty?: boolean;
      showQt?: boolean;
      alwaysFullPrice?: boolean;
    }
  >(),
  {
    hidePlusVat: true,
  },
);

const ouiaProps = useOUIAProps(props);
</script>
